/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment, useEffect, useLayoutEffect, useRef, useState } from "react";
import Header from "./Header";
import SideBar from "./SideBar";
import { useDispatch, useSelector } from "react-redux";
import { setSiteMode, resetSiteMode } from "../Store/settings/siteSettings";
import DraggableSidebar from "../components/DraggableSidebar";
import Modal from "../components/Modal";
import dimond from "../assets/images/greyled-activity.svg";
import InnerHeader from "../components/InnerHeader";
import DeleteModal from "../components/DeleteModal";
import moment from "moment";
import R from "../assets/images/r.svg";
import ActivitySetModal from "../components/AvtivitySetModal";
import RightBar from "../components/RightBar";
import storage from "../services/storage";
import { useNavigate } from "react-router-dom";
import { assignModeChangeSection } from "../Store/api/activities";
import MediaComponent from "../components/createmode/MediaComponent";
import { setBookLoader } from "../Store/ui/loaders";
import { toast } from "react-toastify";

import {
  setActivities,
  replaceActivity,
  setBook
} from "../Store/entities/book";
import { show as singleBook } from "../Store/api/books";
const currentDate = new Date();
const year = currentDate.getFullYear().toString().slice(-2);
const formattedDate = `${currentDate.toLocaleString("default", {
  month: "short"
})} ‘${year}`;

const currentMonth = moment().month();
const daysInMonth = moment().daysInMonth();

const datesArray = [];
for (let day = 1; day <= daysInMonth; day++) {
  const date = moment().month(currentMonth).date(day);
  datesArray.push(date.date());
}

const middleIndex = Math.floor(datesArray.length / 2);

const firstDatesArray = datesArray.slice(0, middleIndex - 1);
const secondDatesArray = datesArray.slice(middleIndex - 1);

const TeachMode = () => {
  const Storeuser = storage.get("user");
  const navigate = useNavigate();
  const { reader } = useSelector((state) => state.ui.reader);
  const { book } = useSelector((state) => state.entities);

  const { user } = useSelector((state) => state.auth);
  const { loaders } = useSelector((state) => state.ui);
  const { settings } = useSelector((state) => state.settings.settings);
  const { topScroll } = reader;
  const [tabContent, setTabContent] = useState("content");
  const [scrollToId, setScrollToId] = useState(null);
  const [highlightedSection, setHighlightedSection] = useState(null);
  const [showCalendar, setShowCalendar] = useState(undefined);

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);

  const [creatingActivity, setCreatingActivity] = useState(undefined);
  const [draggedOver, setDraggedOver] = useState(null);
  const [writingActivity, setWritingActivity] = useState(false);

  const [reverse, setReverse] = useState(false);
  const [highlightedIndexes, setHighlightedIndexes] = useState([]);
  const [isResizing, setIsResizing] = useState(false);
  const [draggedChap, setDraggedChap] = useState("");
  const [selectedParagraphs, setSelectedParagraphs] = useState([]);

  const [isScrolling, setIsScrolling] = useState(false);
  const [highlightedParagraph, setHighlightedParagraph] = useState(null);
  const [isDraggingActivity, setIsDraggingActivity] = useState(false);
  const [draggedActivity, setDraggedActivity] = useState(null);
  const [activities, setActivities] = useState([]);
  const [value, setValue] = useState(true);
  const [greyedItem, setGreyedItem] = useState("");
  const [greyedParagraphs, setGreyedPharagraphs] = useState([]);

  const [draggedActivityPosition, setDraggedActivityPosition] = useState({
    top: 0,
    left: 0
  });
  const [activitySetModal, setActivitySetModal] = useState({
    show: false,
    choice: ""
  });
  const [books, setBooks] = useState({
    book: {},
    chapters: [],
    activities: []
  });
  const [isDateGreater14, setIsDateGreater14] = useState(
    currentDate.getDate() > 14
  );
  const [selectedActivity, setSelectedActivity] = useState({});
  const [visibleElements, setVisibleElements] = useState({
    parentOrder: null,
    childOrder: null
  });
  const elementRefs = useRef({});
const handleScroll = () => {
  // Get current scroll position (from top of document)
  const scrollPosition = window.scrollY;
  // Calculate the trigger point (80% of viewport height from top)
  const triggerPoint = scrollPosition + window.innerHeight * 0.7;

  Object.entries(elementRefs.current).forEach(([key, el]) => {
    if (el) {
      const rect = el.getBoundingClientRect();
      const elementTop = rect.top + window.scrollY;
      const elementBottom = elementTop + rect.height;
      
      // Check if trigger point is within this element (20% from bottom)
      if (triggerPoint > elementTop && triggerPoint < elementBottom) {
        const [parentOrder, childOrder] = key.split("-").map(Number);
        setVisibleElements({ parentOrder, childOrder });
      }
    }
  });
};
  useLayoutEffect(() => {
    if (Storeuser.status === "denied")
      navigate("/access-denied", { replace: true });
  }, [Storeuser.status]);

  const dispatch = useDispatch();
  const scrollerRef = useRef(null);

  useEffect(() => {
    dispatch(setSiteMode("teach"));
    return () => {
      dispatch(resetSiteMode());
    };
  }, []);

  const lastBookId = localStorage.getItem("lastBookId");
  useEffect(() => {
    if (lastBookId) {
      dispatch(
        singleBook({
          id: lastBookId,
          onSuccess: (res) => {
            const bookData = res?.data?.data;
            dispatch(setBook(bookData));
            setValue(false);
          }
        })
      );
    }
  }, []);

  useEffect(() => {
    setActivities(book.activities);
    return () => {};
  }, [book.activities]);

  useEffect(() => {
    if (scrollToId) {
      const div = document.getElementById(scrollToId);
      if (div) {
        div.scrollIntoView({ block: "start", behavior: "smooth" });
        setScrollToId(null);
      }
    }
  }, [scrollToId]);

  useEffect(() => {
    if (scrollerRef.current) {
      scrollerRef.current.scrollTop = topScroll;
    }
  }, [scrollerRef.current]);

  const scrollableContent = (scroller) => {
    scrollerRef.current = scroller;
  };

  const scrollToSection = (sec) => {
    setScrollToId(sec);
  };

  const scrollToChapter = (chap, chapSec) => {
    setScrollToId(chap);
  };

  const scrollToParagraph = (chap, sec, par) => {
    setScrollToId(`${chap}.${sec}.${par}`);
  };
  const highlightChapter = (e, value) => {
    setGreyedItem("");
    setGreyedPharagraphs([]);
    setHighlightedIndexes([]);
    if (highlightedSection === value) {
      setHighlightedSection(null);
      setActivities(book.activities);
    } else {
      if (creatingActivity) return;
      setHighlightedSection(value);
      setActivities(book.activities.filter((e) => e.chapter === value));
      // setScrollToId(value);
    }
  };
  const highlightSection = (e, value) => {
    setGreyedItem("");
    setGreyedPharagraphs([]);
    if (highlightedSection === value) {
      setHighlightedSection(null);
      setActivities(activities);
    } else {
      if (creatingActivity) return;
      setHighlightedSection(value);
      setActivities(
        book.activities.filter(
          (e) => e.section === value && e.paragraphs.length === 0
        )
      );
      // setScrollToId(value);
    }
  };

  const greyedItemSetter = (activity) => {
    if (!activity.section && activity.paragraphs.length === 0) {
      if (greyedItem === activity.chapter) {
        setGreyedItem("");
      } else {
        setGreyedItem(activity.chapter);
      }
    } else if (activity.section && activity.paragraphs.length === 0) {
      if (greyedItem === activity.section) {
        setGreyedItem("");
      } else {
        setGreyedItem(activity.section);
      }
    } else {
      if (
        JSON.stringify(greyedParagraphs) == JSON.stringify(activity.paragraphs)
      ) {
        setGreyedPharagraphs([]);
      } else {
        setGreyedPharagraphs(activity.paragraphs);
      }
    }
  };

  const scrollTo = (activity) => {
    if (activity.chapter && !activity.section) {
      setDraggedOver({ index: activity.chapter, type: "chapter" });
      setHighlightedIndexes([]);
      setDraggedChap("");
    } else if (activity.section && !activity.paragraphs.length) {
      setDraggedOver({
        index: `${activity.chapter}.${activity.section}`,
        type: "section"
      });
      setHighlightedIndexes([]);
    } else {
      setDraggedOver(null);
      setHighlightedIndexes(
        activity.paragraphs.map(
          (p) => `${activity.chapter}.${activity.section}.${p}`
        )
      );
      setDraggedChap(`${activity.chapter}.${activity.section}`);
    }
    let greyedId = activity.chapter;
    let setId = activity.chapter;
    if (activity.section) {
      greyedId = activity.section;
      setId += `.${activity.section}`;
    }
    if (activity.paragraphs && activity.paragraphs.length) {
      setGreyedPharagraphs(activity.paragraphs);
      greyedId = "";
      setId += `.${activity.paragraphs[0]}`;
    }
    setGreyedItem(greyedId);
    // setScrollToId(setId);
    const div = document.getElementById(setId);
    if (div) {
      const rect = div.getBoundingClientRect();
      const isCentered = !(
        rect.top < 100 || rect.top > window.innerHeight - 60
      );
      if (!isCentered) {
        div.scrollIntoView({ block: "start" });
        // setTimeout(() => {
        scrollerRef.current.scrollTop -= 10;
        // }, 600);
      }
    }
  };
  const setCalendarShow = (bool) => {
    setShowCalendar(bool);
  };

  const reverseIt = (e) => {
    setReverse(!reverse);
  };

  const scrollWithSpectrum = (top) => {
    const centreFoldEl = scrollerRef.current;
    centreFoldEl.scrollTop =
      (top / 100) * (centreFoldEl.scrollHeight - centreFoldEl.clientHeight);
    // const { scrollTop } = centreFoldEl;
    // scrollerRef.current.scrollTop = top;
  };

  const dynamicPStyles = (chap, section, paragraph) => {
    let className = "theme_para_se paragraph_element main_p unique_paragraph";

    className +=
      book.activities.findIndex((e) => e.paragraphs.includes(paragraph._id)) >
      -1
        ? " rich"
        : "";
    className += settings.fontLarge ? " fontLarge" : "";
    className += highlightedIndexes.includes(
      `${chap._id}.${section._id}.${paragraph._id}`
    )
      ? " activated_p_tags"
      : "";
    className +=
      highlightedParagraph === paragraph._id ||
      greyedParagraphs.includes(paragraph._id)
        ? " bg_grey"
        : "";

    return className;
  };

  const dynamicSectionStyles = (chap, section) => {
    let className = "section_element";
    className += settings.fontLarge ? " fontLarge" : "";
    className +=
      highlightedSection === `${section._id}` || greyedItem === section._id
        ? " highlighted"
        : "";
    // className += draggedOver && draggedOver.type === 'section' && draggedOver.index === `${chap._id}.${section._id}` ? ' trigger' : '';

    return className;
  };

  const handleClassSectionChange = (classIds = [], sectionIds = []) => {
    dispatch(
      assignModeChangeSection({
        body: {
          classId: classIds,
          sectionsId: sectionIds
        },
        onSuccess: (res) => {
          const { data = [] } = res?.data || {};
          // setActivities([...data, ...activities]);
        },
        onError: (error) => {
          toast.error("Error", error?.response?.data?.message);
        }
      })
    );
  };
  const handleActivityTitleClick = (activityId) => {
    setActivities(book.activities.filter((e) => e?._id === activityId));
  };
  return (
    <>
      <div>
        <section
          className="class_room_wrap teach mt-0"
          style={{ overflowY: "clip" }}>
          <div>
            <div
              className={`flex-container`}
              onMouseDown={(e) => {
                document.body.classList.add("noselect");
              }}
              onMouseMove={(event) => {
                event.preventDefault();
                if (isDraggingActivity) {
                  setDraggedActivityPosition({
                    top: (event.clientY / window.innerHeight) * 100,
                    left: (event.clientX / window.innerWidth) * 100
                  });
                }
                if (!dragging) return;
                const left = (event.clientX / window.innerWidth) * 100; // percentage of viewport width
                const top = (event.clientY / window.innerHeight) * 100; // percentage of viewport height
                setMousePosition({ x: left, y: top });
                if (isScrolling) {
                  const { clientY: y } = event;
                  const { scrollTop } = scrollerRef.current;
                  scrollerRef.current.scrollTop = scrollTop + y;
                }
              }}
              onMouseUp={(e) => {
                if (isResizing) setIsResizing(false);
                if (isScrolling) setIsScrolling(false);
                if (isDraggingActivity) {
                  setIsDraggingActivity(false);
                }
                e.stopPropagation();
              }}>
              <div className="activity-spectrum">
                <div>
                  <DraggableSidebar
                    scrollPara={scrollToParagraph}
                    scrollBook={scrollToSection}
                    scrollToSection={scrollToSection}
                    scrollToParagraph={scrollToParagraph}
                    scrollToChapter={scrollToChapter}
                    setParentIsScrolling={setIsScrolling}
                    scrollCentre={scrollWithSpectrum}
                    isScrolling={isScrolling}
                    setScrollToId={setScrollToId}
                  />
                </div>
              </div>
              <div className="side-nav">
                <SideBar
                  handleActivityTitleClick={handleActivityTitleClick}
                  lastBookId={lastBookId}
                  isDraggingActivity={isDraggingActivity}
                  draggedActivity={draggedActivity}
                  draggedOver={draggedOver}
                  anchorBook={scrollToParagraph}
                  scrollChapter={scrollToChapter}
                  scrollSection={scrollToSection}
                  handleCalnendarShow={setCalendarShow}
                  mode={"assign"}
                  handleTabChange={setTabContent}
                  tabContents="content"
                />
              </div>
              <div className="centre-fold">
                <Header
                  book={book}
                  setValue={setValue}
                  tabContent={tabContent}
                  handleClassSectionChange={handleClassSectionChange}
                />
                <div className={`row ${reverse ? "reverse" : ""}`}>
                  <div
                    className="col-xl-7 col-lg-12"
                    style={{ paddingRight: "0px" }}
                    >
                    <InnerHeader
                      lastBookId={lastBookId}
                      visibleElements={visibleElements}
                      value={value}
                      book={book}
                      highlightedSection={highlightedSection}
                      writingActivity={writingActivity}
                      creatingActivity={creatingActivity}
                    />
                    <div
                      className="center_content"
                      onScroll={handleScroll}
                      style={{
                        height: " calc(98vh - 106px)",
                        paddingLeft: "5px",
                        marginRight: "0px"
                      }}
                      ref={scrollableContent}>
                      <Fragment>
                        {loaders.bookLoader || !book || !book._id ? (
                          // Render your chapter/section/paragraph skeletons here
                          <>
                            <div
                              className={`book chapter_element `}
                              style={{
                                position: "relative",
                                paddingLeft: "2rem",
                                paddingTop: "4px"
                              }}>
                              <div className="chap-load">
                                <div
                                  className="content-skeleton mb-0 inner-head-load"
                                  style={{
                                    height: "58px",
                                    width: "64%",
                                    borderRadius: "4px"
                                  }}></div>
                                <div
                                  className="content-skeleton mb-0 inner-head-load"
                                  style={{
                                    height: "29px",
                                    width: "94%",
                                    borderRadius: "4px"
                                  }}></div>
                              </div>

                              <div className="" style={{ marginTop: "32px" }}>
                                <div
                                  className="content-skeleton  inner-head-load"
                                  style={{
                                    height: "38px",
                                    width: "38%",
                                    borderRadius: "4px",
                                    marginBottom: "4px"
                                  }}></div>
                                <div
                                  className="content-skeleton  inner-head-load"
                                  style={{
                                    height: "116px",
                                    width: "94%",
                                    borderRadius: "4px",
                                    marginBottom: "32px"
                                  }}></div>
                                <div
                                  className="content-skeleton  inner-head-load"
                                  style={{
                                    height: "319px",
                                    width: "94%",
                                    borderRadius: "4px",
                                    marginBottom: "20px"
                                  }}></div>
                                <div
                                  className="content-skeleton  inner-head-load"
                                  style={{
                                    height: "290px",
                                    width: "94%",
                                    borderRadius: "4px"
                                  }}></div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            {!loaders.bookLoader &&
                              book &&
                              book?.chapters &&
                              book?.chapters?.map((chap, chapInd) => (
                                <div
                                  className={`book chapter_element ${
                                    highlightedSection === chap._id ||
                                    greyedItem === chap._id
                                      ? "highlighted"
                                      : ""
                                  }`}
                                  data-id={chapInd}
                                  key={chap.order}
                                  id={chap._id}
                                  style={{
                                    position: "relative",
                                    paddingLeft: "2rem",
                                    paddingTop: "4px"
                                  }}>
                                  <>
                                    {book?.activities?.findIndex(
                                      (e) =>
                                        e.chapter === chap._id && !e.section
                                    ) > -1 && (
                                      <>
                                        {" "}
                                        <img
                                          src={dimond}
                                          alt="diamond"
                                          className="cursor"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setHighlightedParagraph(null);
                                            setGreyedPharagraphs([]);
                                            highlightChapter(e, `${chap._id}`);
                                            setHighlightedIndexes([]);
                                            setDraggedOver(null);
                                          }}
                                          style={{
                                            position: "absolute",
                                            top: 3,
                                            right: 3
                                          }}
                                        />
                                      </>
                                    )}
                                    <h4
                                      className={`sub_heading max_550 chapter_element w-95 ${
                                        draggedOver &&
                                        draggedOver.type === "chapter" &&
                                        draggedOver.index == chap._id
                                          ? ""
                                          : ""
                                      }`}
                                      data-id={chap._id}
                                      dangerouslySetInnerHTML={{
                                        __html: chap.title
                                      }}></h4>
                                    <p
                                      style={{ width: "97%" }}
                                      className={
                                        settings.fontLarge
                                          ? "theme_para_se chapter_element fontLarge"
                                          : "theme_para_se chapter_element"
                                      }
                                      data-id={chap._id}
                                      dangerouslySetInnerHTML={{
                                        __html: chap.description
                                      }}></p>
                                    <hr className="activity-line" />
                                  </>

                                  {chap.sections.map((section, secIndex) => (
                                    <div
                                      key={section.order}
                                      ref={(el) =>
                                        (elementRefs.current[
                                          `${chap.order}-${section.order}`
                                        ] = el)
                                      }
                                      data-parent-order={chap.order}
                                      data-child-order={section.order}
                                      id={`${chap._id}.${section._id}`}
                                      data-id={`${chap._id}.${section._id}`}
                                      className={dynamicSectionStyles(
                                        chap,
                                        section
                                      )}
                                      style={{ position: "relative" }}>
                                      <Fragment>
                                        {book?.activities?.findIndex(
                                          (e) =>
                                            e.section == section._id &&
                                            !e.paragraphs.length
                                        ) > -1 ? (
                                          <>
                                            <img
                                              src={dimond}
                                              alt="diamond"
                                              className="cursor"
                                              onClick={(e) => {
                                                setHighlightedParagraph(null);
                                                setGreyedPharagraphs([]);
                                                highlightSection(
                                                  e,
                                                  `${section._id}`
                                                );
                                              }}
                                              style={{
                                                position: "absolute",
                                                top: 3,
                                                right: 4
                                              }}
                                            />
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        <h5
                                          className={`mt-3 w-95 ${
                                            book?.activities?.findIndex(
                                              (e) => e.section == section._id
                                            ) > -1
                                              ? "rich"
                                              : ""
                                          }`}
                                          dangerouslySetInnerHTML={{
                                            __html: section.title
                                          }}></h5>

                                        {section.description ? (
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html: section.description
                                            }}></p>
                                        ) : (
                                          ""
                                        )}

                                        {highlightedIndexes.length > 0 &&
                                        draggedChap ===
                                          `${chap._id}.${section._id}`
                                          ? ""
                                          : // <OutlineElement
                                            //   // top={pTop}
                                            //   // height={outlineHeight}
                                            //   // resizingSet={resizingSet}
                                            // />
                                            ""}
                                        {section.paragraphs.map((paragraph) => {
                                          const uniqueKey = `${paragraph._id}`;
                                          return (
                                            <>
                                              {(paragraph?.text ||
                                                (paragraph?.type ===
                                                  "paragraph" &&
                                                  paragraph?.media.length >
                                                    0)) && (
                                                <div
                                                  key={uniqueKey} // ✅ Correct key directly on the top-level element
                                                  data-id={paragraph._id}
                                                  data-secid={section._id}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    setCalendarShow(false);
                                                  }}>
                                                  {paragraph.title && (
                                                    <h6
                                                      className="mini_heading paragraph_element w-95"
                                                      data-id={paragraph._id}
                                                      dangerouslySetInnerHTML={{
                                                        __html: paragraph.title
                                                      }}
                                                    />
                                                  )}
                                                  <div
                                                    className={dynamicPStyles(
                                                      chap,
                                                      section,
                                                      paragraph
                                                    )}
                                                    data-id={`${chap._id}.${section._id}.${paragraph._id}`}
                                                    id={`${chap._id}.${section._id}.${paragraph._id}`}
                                                    style={{
                                                      position: "relative",
                                                      marginTop: "18px"
                                                    }}>
                                                    {book.activities.findIndex(
                                                      (e) =>
                                                        e.paragraphs.includes(
                                                          paragraph._id
                                                        ) &&
                                                        (e.paragraphs.length ===
                                                          1 ||
                                                          [...e.paragraphs]
                                                            .sort(
                                                              (a, b) => a - b
                                                            )
                                                            .indexOf(
                                                              paragraph._id
                                                            ) === 0)
                                                    ) > -1 && (
                                                      <img
                                                        src={dimond}
                                                        alt="diamond"
                                                        className="cursor"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          setHighlightedSection(
                                                            null
                                                          );
                                                          setGreyedPharagraphs(
                                                            []
                                                          );
                                                          setGreyedItem("");

                                                          if (
                                                            highlightedParagraph ===
                                                            paragraph._id
                                                          ) {
                                                            setHighlightedParagraph(
                                                              null
                                                            );
                                                            setGreyedItem("");
                                                            setActivities(
                                                              book.activities
                                                            );
                                                          } else {
                                                            setHighlightedParagraph(
                                                              paragraph._id
                                                            );
                                                            setGreyedPharagraphs(
                                                              book.activities
                                                                .filter((e) =>
                                                                  e.paragraphs.includes(
                                                                    paragraph._id
                                                                  )
                                                                )
                                                                .flatMap(
                                                                  (obj) =>
                                                                    obj.paragraphs
                                                                )
                                                            );
                                                            setActivities(
                                                              book.activities.filter(
                                                                (e) =>
                                                                  e.paragraphs.includes(
                                                                    paragraph._id
                                                                  )
                                                              )
                                                            );
                                                          }
                                                        }}
                                                        style={{
                                                          position: "absolute",
                                                          top: 0,
                                                          right: 3
                                                        }}
                                                      />
                                                    )}

                                                    <div
                                                      style={{ width: "96%" }}
                                                      dangerouslySetInnerHTML={{
                                                        __html: paragraph.text
                                                      }}
                                                    />
                                                    {paragraph.video?.link && (
                                                      <div className="p-media">
                                                        <video
                                                          src={
                                                            paragraph.video.link
                                                          }
                                                          controls
                                                          width="100%"
                                                        />
                                                        <span>
                                                          {
                                                            paragraph.video
                                                              .description
                                                          }
                                                        </span>
                                                      </div>
                                                    )}
                                                    {paragraph.media && (
                                                      <>
                                                        {paragraph.media.map(
                                                          (media, mIndex) => (
                                                            <MediaComponent
                                                              key={`${paragraph._id}-media-${mIndex}`}
                                                              chapterIndex={
                                                                chapInd
                                                              }
                                                              secInd={secIndex}
                                                              pIndex={uniqueKey}
                                                              setBook={setBooks}
                                                              book={books}
                                                              media={media}
                                                              index={mIndex}
                                                              parent="paragraph"
                                                              parentId={
                                                                paragraph._id
                                                              }
                                                            />
                                                          )
                                                        )}
                                                      </>
                                                    )}
                                                    {paragraph.image?.link && (
                                                      <div className="p-media">
                                                        <img
                                                          src={
                                                            paragraph.image.link
                                                          }
                                                        />
                                                        <span>
                                                          {
                                                            paragraph.image
                                                              .description
                                                          }
                                                        </span>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          );
                                        })}
                                      </Fragment>
                                    </div>
                                  ))}

                                  <div
                                    className="chapter_element"
                                    data-id={chap._id}
                                    style={{
                                      width: "100%",
                                      height: "1px"
                                    }}></div>
                                </div>
                              ))}
                          </>
                        )}
                      </Fragment>

                      <div style={{ height: "60px" }}></div>
                      {!creatingActivity && !writingActivity ? (
                        <div
                          className="page_nation teach"
                          id="calendar-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowCalendar(true);
                          }}
                          onMouseEnter={() => {
                            if (isDraggingActivity) {
                              setShowCalendar(true);
                            }
                          }}>
                          <h6 className="cursor">{formattedDate}</h6>
                          <ul>
                            {isDateGreater14 && (
                              <li>
                                <a
                                  href=""
                                  className="last-child teach"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setIsDateGreater14(false);
                                  }}>
                                  <img
                                    src={R}
                                    alt="arrow_right_page"
                                    style={{ transform: "scaleX(-1)" }}
                                  />
                                </a>
                              </li>
                            )}
                            {!isDateGreater14
                              ? firstDatesArray.map((day, index) => (
                                  <li key={index} style={{ cursor: "pointer" }}>
                                    <a
                                      className={
                                        currentDate.getDate() === day
                                          ? "active"
                                          : ""
                                      }>
                                      {day}
                                    </a>
                                  </li>
                                ))
                              : secondDatesArray.map((day, index) => (
                                  <li key={index} style={{ cursor: "pointer" }}>
                                    <a
                                      href="#!"
                                      className={
                                        currentDate.getDate() === day
                                          ? "active"
                                          : ""
                                      }>
                                      {day}
                                    </a>
                                  </li>
                                ))}
                            {!isDateGreater14 && (
                              <li>
                                <a
                                  href="#!"
                                  className="last-child teach"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setIsDateGreater14(true);
                                  }}>
                                  <img src={R} alt="arrow_right_page" />
                                </a>
                              </li>
                            )}
                          </ul>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-xl-5 col-lg-12">
                    <RightBar
                      mode={"assign"}
                      scrollTo={scrollTo}
                      creatingActivity={creatingActivity}
                      writingActivity={writingActivity}
                      setCreatingActivity={setCreatingActivity}
                      setWritingActivity={setWritingActivity}
                      setDraggedOver={setDraggedOver}
                      setHighlightedIndexes={setHighlightedIndexes}
                      setReverse={setReverse}
                      reverseIt={reverseIt}
                      selectedParagraphs={selectedParagraphs}
                      draggedChap={draggedChap}
                      dragging={dragging}
                      draggedActivity={draggedActivity}
                      isDraggingActivity={isDraggingActivity}
                      setDraggedActivity={setDraggedActivity}
                      greyedItemSetter={greyedItemSetter}
                      draggedActivityPosition={draggedActivityPosition}
                      setMousePosition={setMousePosition}
                      mousePosition={mousePosition}
                      showCalendar={showCalendar}
                      reverse={reverse}
                      highlightedSection={highlightedSection}
                      activities={activities}
                      setActivitySetModal={setActivitySetModal}
                      setDraggedActivityPosition={setDraggedActivityPosition}
                      setDragging={setDragging}
                      setIsDraggingActivity={setIsDraggingActivity}
                      scrollToChapter={scrollToChapter}
                      setDraggedChap={setDraggedChap}
                      bookId={book._id}
                      setSelectedActivity={setSelectedActivity}
                      selectedActivity={selectedActivity}
                      setActivities={setActivities}
                      showClearBtn={
                        greyedParagraphs?.length > 0 ||
                        greyedItem ||
                        highlightedSection
                      }
                      onClear={() => {
                        setGreyedPharagraphs([]);
                        setHighlightedIndexes([]);
                        setHighlightedParagraph(null);
                        setHighlightedSection("");
                        setGreyedItem("");
                        setActivities(book.activities);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            handleCalnendarShow={setCalendarShow}
            isDraggingActivity={isDraggingActivity}
            draggedActivity={draggedActivity}
            setDraggedActivityPosition={setDraggedActivityPosition}
            setIsDraggingActivity={setIsDraggingActivity}
            showCalendar={showCalendar}
            setShowCalendar={setShowCalendar}
            setActivities={setActivities}
            book={book}
            setSelectedActivity={setSelectedActivity}
            selectedActivity={selectedActivity}
          />
        </section>
        {<DeleteModal />}
        <ActivitySetModal
          show={activitySetModal.show}
          options={activitySetModal}
          setActivitySetModal={setActivitySetModal}
          setCreatingActivity={setCreatingActivity}
        />
      </div>
    </>
  );
};

export default TeachMode;
